import { Editor } from '../core/Editor';
import { BaseTool } from './BaseTool';
import { MoveTool } from './MoveTool';
import { MarqueeTool } from './MarqueeTool';
import { MagicWandTool } from './MagicWandTool';
import { CropTool } from './CropTool';
import { BrushTool } from './BrushTool';
import { EraserTool } from './EraserTool';
import { SmudgeTool } from './SmudgeTool';
import { HealingTool } from './HealingTool';
import { BucketTool } from './BucketTool';
import { TextTool } from './TextTool';
import { EyedropperTool } from './EyedropperTool';
import { HandTool } from './HandTool';
import { BgRemoveTool } from './BgRemoveTool';
import { ToolType } from '../types';

export class ToolManager {
  private editor: Editor;
  private tools: Map<ToolType, BaseTool> = new Map();
  public activeTool: BaseTool;

  constructor(editor: Editor) {
    this.editor = editor;

    // Register all tools
    this.register(new MoveTool(editor));
    this.register(new MarqueeTool(editor));
    this.register(new MagicWandTool(editor));
    this.register(new CropTool(editor));
    this.register(new BrushTool(editor));
    this.register(new EraserTool(editor));
    this.register(new SmudgeTool(editor));
    this.register(new HealingTool(editor));
    this.register(new BucketTool(editor));
    this.register(new BgRemoveTool(editor));
    this.register(new TextTool(editor));
    this.register(new EyedropperTool(editor));
    this.register(new HandTool(editor));

    this.activeTool = this.tools.get('move')!;
  }

  private register(tool: BaseTool) {
    this.tools.set(tool.id, tool);
  }

  public getTool(id: ToolType): BaseTool | undefined {
    return this.tools.get(id);
  }

  public setTool(id: ToolType): BaseTool {
    const nextTool = this.tools.get(id);
    if (!nextTool) return this.activeTool;

    if (this.activeTool) {
      this.activeTool.onDeactivate();
    }
    this.activeTool = nextTool;
    this.activeTool.onActivate();
    this.editor.updateCursor();
    this.editor.onToolChange(id);
    return this.activeTool;
  }
}
